import {HTTP} from '@/CallAPI'
export default {
  storeSurvey (survey = {}) {
    return HTTP.post('surveys', survey)
  },
  listSurveys () {
    return HTTP.get('surveys')
  },
  showSurvey (id = '') {
    return HTTP.get('surveys/' + id)
  },
  destroySurvey (survey = {}) {
    return HTTP.delete('surveys/' + survey.id)
  },
  updateSurvey (survey = {}) {
    return HTTP.put('surveys/' + survey.id, survey)
  }
}



// WEBPACK FOOTER //
// ./src/service/survey.js